import {PlatformTable} from "../PlatformTable";
import withBreakpoint from "../../util/withBreakpoint";
import {withAppContext} from "../../util/withAppContext";

interface ReportResultTable {
    state: any;
    props: any;
    applet: any;
}

// A report's rows, as a grid.
//
// PlatformTable, like every other list in this app -- Ed has corrected this three times now (t6
// Portal Users, this app's Tables landing page, the reference-list values editor) and the third
// correction overruled an argument that the case was different. It is not a different case. What
// the conversion buys here is the same as everywhere: column show/hide, resizing, an honest footer
// count, the 48px row conventions and the simple-search box, none of which a hand-rolled <table>
// over rows.map() has and none of which anybody was going to add to it.
//
// NOTHING IS EDITABLE and nothing is clickable. A report row is a computed aggregate -- there is no
// record behind "Quality, 19.13" to open, and a row that looked clickable and did nothing would be
// worse than one that plainly is not.
class ReportResultTable extends PlatformTable {

    // The buffer during a refetch is the PREVIOUS one -- the guard every sibling table carries,
    // because a renderer reading the new buffer mid-fetch indexes past its end.
    row(params: any) {
        const buffer = this.state.fetchBackgroundOperation ? this.state.previousBuffer : this.state.buffer;
        if (!buffer || params.row.id > buffer.length - 1) return null;
        return buffer[params.row.id];
    };
}

export default withAppContext(withBreakpoint(ReportResultTable));
